import { useEffect, useState } from "react";
import { deleteRule, getDisableDays } from "../APIs/api-routes.util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import Header from "../Dashboard/Header";
import DataTable from "react-data-table-component";
import Loader from "../common/spinner";
import { isMobile } from "react-device-detect";

function DisableDays() {
  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const getAllDay = () => {
    setShowLoader(true)

    getDisableDays().subscribe((res: any) => {
    setShowLoader(false)

      if ("response" in res && res.response) {
        const response = res.response;
        setData(response);
      }
    });
  };
  const columns = [
    {
      id: "day",
      name: "Day",
      selector: (row: any) => row.Day,
      sortable: true,
    },
    {
      name: "Day Status",
      selector: (row: any) => row.DayStatus,
      sortable: true,
    },
    {
      name: "Start Time",
      selector: (row: any) => (
        <text>{row?.StartTime ? row.StartTime : "--"}</text>
      ),
      sortable: true,
    },
    {
      name: "End Time",
      selector: (row: any) => <text>{row?.EndTime ? row.EndTime : "--"}</text>,
      sortable: true,
    },
    {
      name: "Appointment Close",
      selector: (row: any) => (
        <FontAwesomeIcon
          icon={row.AppointmentClose === "1" ? faCheck : faXmark}
        />
      ),
      sortable: true,
    },{
      name: "Actions",
      selector: (row: any) => (
        <button 
          className="btn btn-danger" 
          style={{
            fontSize: isMobile ? "12px" : "14px",
            padding: isMobile ? "4px 8px" : "6px 12px"
          }}
          onClick={()=> {
            deleteRules(row.ID)
          }}
        >
          {isMobile ? "Del" : "Delete"}
        </button>
      ),
      sortable: true,
    }
  ];

  useEffect(() => {
    getAllDay();
  }, []);


  const deleteRules = (id: any) => {
    setShowLoader(true)
    deleteRule(id).subscribe((res: any) => {
      setShowLoader(false)
      if (res.response.message == "Rule is Deleted") {
        getAllDay();
      }
    })
  }

  return (
    <>
    <Loader show={showLoader}/>

      <Header  />
      <div className="main-container">
        <DataTable
          fixedHeader
          pagination
          responsive
          theme="solarized"
          fixedHeaderScrollHeight={isMobile ? "calc(100vh - 150px)" : "calc(100vh - 135px)"}
          paginationRowsPerPageOptions={isMobile ? [10, 15, 20] : [15, 20, 25, 30, 50]}
          columns={columns}
          data={data}
          // add default sorting to first column desc
          defaultSortFieldId="day"
          defaultSortAsc={false}
          
        />
      </div>
    </>
  );
}

export default DisableDays;
